import HighlightContainer from 'flow/components/ui-components/HighlightContainer';
import useAppContext from 'flow/hooks/useAppContext';
import { TranscriptionExtendedResultCode } from 'flow/types/CallRecord';

export const translationKeyByResultCode: Partial<
    Record<TranscriptionExtendedResultCode, string>
> = {
    NO_CONTENT: 'ai.transcript.no_content',
    AUDIO_FILE_TOO_SMALL: 'ai.transcript.audio_too_small',
    ERROR: 'ai.transcript.failed',
    UNKNOWN: 'ai.transcript.failed',
};

interface Props {
    resultCode: TranscriptionExtendedResultCode;
}

const TranscriptionResultInfo = ({ resultCode }: Props) => {
    const { i18next } = useAppContext();
    const translationKey = translationKeyByResultCode[resultCode];
    if (!translationKey) return null;

    return (
        <HighlightContainer
            type="error"
            title={i18next.t('ai.transcript.unavailable')}
            body={i18next.t(translationKey)}
        />
    );
};

export default TranscriptionResultInfo;
